// extracted by mini-css-extract-plugin
export default {"iframe":"iframe-dQQP"};